/**
 * Ventana modal para mostrar los detalles de la lista de materiales
 */
export const modalListaMaterialesMaterialElement = document.getElementById("modal-lista-materiales-material");

/**
 * Etiqueta para mostrar la cantidad requerida del material padre
 */
export const modalListaMaterialesCantidadRequeridaElement = document.getElementById(
    "modal-lista-materiales-cantidad-requerida",
);

/**
 * Etiqueta para mostrar la fecha inicial del material padre
 */
export const modalListaMaterialesFechaInicialElement = document.getElementById("modal-lista-materiales-fecha-inicial");
